import React from 'react'

interface EmptyStateProps {
  showUpdatedOnly: boolean
  allLoadedOrganizations: any[]
  isFetching: boolean
}

const EmptyState: React.FC<EmptyStateProps> = ({
  showUpdatedOnly,
  allLoadedOrganizations,
  isFetching,
}) => {
  if (isFetching) return null

  return null
}

export default EmptyState
